export default "* STOMP/Rytme\n* Musik\n* Rim\n* Rimord\n";